import { Create } from 'react-admin';
import { RoleForm } from './Role.Form';

export const RoleCreate = () => (
    <Create redirect="list">
        <RoleForm />
    </Create>
);
